import React, { useState, useCallback } from 'react';
import { ThemeProvider } from './ThemeContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Education from './components/Education';
import Portfolio from './components/Portfolio';
import Achievements from './components/Achievements';
import GitHubActivity from './components/GitHubActivity';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SplashScreen from './components/SplashScreen';
import CustomCursor from './components/CustomCursor';
import ParallaxBackground from './components/ParallaxBackground';
import PageTransition from './components/PageTransition';
import SectionDivider from './components/SectionDivider';

function App() {
  const [splashDone, setSplashDone] = useState(false);

  const handleSplashComplete = useCallback(() => {
    setSplashDone(true);
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        {/* Custom Cursor – always present */}
        <CustomCursor />

        {/* Splash Screen Overlay */}
        {!splashDone && <SplashScreen onComplete={handleSplashComplete} />}

        {/* Parallax Background */}
        {splashDone && <ParallaxBackground />}

        {/* Main Content – revealed after splash */}
        <PageTransition show={splashDone}>
          <Navbar />
          <main>
            <Home />
            <SectionDivider />
            <About />
            <SectionDivider />
            <Skills />
            <SectionDivider />
            <Education />
            <SectionDivider />
            <Portfolio />
            <SectionDivider />
            <Achievements />
            <SectionDivider />
            <GitHubActivity />
            <SectionDivider />
            <Blog />
            <SectionDivider />
            <Contact />
          </main>
          <Footer />
        </PageTransition>
      </div>
    </ThemeProvider>
  );
}

export default App;